/**
 * Created by qiushaoyu on 2017/12/6.
 */
import Qs from 'qs'
import i18n from "../locale/i18n";

export default {
    // 基础url前缀
    // baseURL: base_url,
    // baseURL: "http://117.139.166.13:2034",
    // baseURL: "http://112.13.96.195:3080",
    // baseURL: "/ticket_racing",
    //设置超时时间
    timeout: 50000,
    //返回数据类型
    responseType: 'json', // default
    // 请求头信息
    headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json;charset=UTF-8',
        lang: i18n.locale,
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },


    // url: '/get',
    // method: 'POST',
    // transformRequest: [function (data) {
    //   let ret = '';
    //   for (let it in data) {
    //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //   }
    //   return ret
    // }],
    transformResponse: [
        // 这里提前处理返回的数据
        function (data) {
            // console.log(data)
            return data;
        }
    ],

    //parameter参数
    params: {},

    /* paramsSerializer: function (params) {
     return Qs.stringify(params)
     },
     */
    //post参数
    data: {},


    // withCredentials: false, // default


    //将upload事件注释掉，防止跨域状态下发起option请求

    // onUploadProgress: function(progressEvent) {
    // 	// Do whatever you want with the native progress event
    // },


    // onDownloadProgress: function(progressEvent) {
    // 	// Do whatever you want with the native progress event
    // },


    // maxContentLength: 2000,


    /*  validateStatus: function (status) {
     return status >= 200 && status < 300; // default
     },*/


    // maxRedirects: 5, // default
}



// WEBPACK FOOTER //
// ./src/axios/config.js